import { Provider } from '@angular/core';

import { PtrabSessionUseCasesImpl } from '@app/domain/use-cases/ptrab/session/session.use-cases';
import { PTRAB_SESSION_USE_CASES } from '@app/domain/use-cases/ptrab/session/session.use-cases.contract';

export const ptrabSessionUseCasesProvider: Provider = {
  provide: PTRAB_SESSION_USE_CASES,
  useClass: PtrabSessionUseCasesImpl
};
